import { IResult } from "./result.interface";

export interface ISaveInterpretedEcg extends Omit<IResult<any>, "data"> {
  failReason?: SaveInterpretedEcgFailureReason;
  postSaveMessageCode?: PostEcgSaveMessageCode;
}

export enum SaveInterpretedEcgFailureReason {
  EcgAlreadySaved = 1,
  Unknown,
}

export enum PostEcgSaveMessageCode {
  EcgMarkedCritical = 1,
  Unknown,
}
